// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared";
import { equal } from "@lg/shared";
import * as z from "zod";
import { immerable } from "immer";

const $schemas = new Map<string, z.ZodObject<any>>();
@jsonClass('Llama.Project')
class Llama__Project {
    @jsonProperty(() => Llama__Project.Id)
    id: Llama__Project.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "string" as const,
        editablePropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "name", "locations", "isActive", "isInternal", "erpId", "ownerEmail", "expenses", "customer", "customerId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "name", "locations", "isActive", "isInternal", "erpId", "ownerEmail", "expenses", "customer", "customerId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: LowgileDataUtil.unwrapReadonly(Object.freeze(["id", "name", "locations", "isActive", "isInternal", "erpId", "ownerEmail", "expenses", "customer", "customerId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: LowgileDataUtil.unwrapReadonly(Object.freeze({ "name": "string", "locations": "string[]", "isActive": "boolean", "isInternal": "boolean", "erpId": "string", "ownerEmail": "string", "expenses": "Llama.Expense[]", "customer": "Llama.Customer", "customerId": "Llama.Customer.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "string" } as const)),
        staticEntityProperties: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: LowgileDataUtil.unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: LowgileDataUtil.unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ customer: () => Llama.Customer } as const)),
        oneToManyRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({ expenses: () => Llama.Expense } as const)),
        oneToOneOwningRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: LowgileDataUtil.unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = String;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θname? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θlocations? = Signals.proxySignalDeferred<string[]>(() => undefined);
    private readonly θisActive? = Signals.proxySignalDeferred<boolean>(() => false);
    private readonly θisInternal? = Signals.proxySignalDeferred<boolean>(() => false);
    private readonly θerpId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θownerEmail? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θexpenses? = Signals.proxySignalDeferred<Llama.Expense[]>(() => undefined);
    private readonly θcustomer? = Signals.proxySignalDeferred<Llama.Customer>(() => undefined);
    private readonly θcustomerId? = Signals.proxySignalDeferred<string>(() => undefined);
    private readonly θcreatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θupdatedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θdeletedOn? = Signals.proxySignalDeferred<Date>(() => undefined);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => undefined);
    private readonly θversionNumber? = Signals.proxySignalDeferred<number>(() => undefined);

    static get __type(): 'Llama.Project' {
        return 'Llama.Project'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Llama.Project' {
        return 'Llama.Project'
    }

    static get __baseType(): 'Llama.Project' {
        return 'Llama.Project'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Llama.Project' {
        return 'Llama.Project'
    }

    get [BoInfoSymbol]() {
        return Llama__Project[BoInfoSymbol]
    }

    get name(): string {
        return this.θname?.()
    }

    set name(name) {
        this.θname.set(LowgileDataUtil.coerceDataType(name, 'string', false, true))
    }

    get locations(): string[] {
        return this.θlocations?.()
    }

    set locations(locations) {
        this.θlocations.set(LowgileDataUtil.coerceDataType(locations, 'string[]', false, true))
    }

    get isActive(): boolean {
        return this.θisActive?.()
    }

    set isActive(isActive) {
        this.θisActive.set(LowgileDataUtil.coerceDataType(isActive, 'boolean', false, true))
    }

    get isInternal(): boolean {
        return this.θisInternal?.()
    }

    set isInternal(isInternal) {
        this.θisInternal.set(LowgileDataUtil.coerceDataType(isInternal, 'boolean', false, true))
    }

    get erpId(): string {
        return this.θerpId?.()
    }

    set erpId(erpId) {
        this.θerpId.set(LowgileDataUtil.coerceDataType(erpId, 'string', false, true))
    }

    get ownerEmail(): string {
        return this.θownerEmail?.()
    }

    set ownerEmail(ownerEmail) {
        this.θownerEmail.set(LowgileDataUtil.coerceDataType(ownerEmail, 'string', false, true))
    }

    get expenses(): Llama.Expense[] {
        return this.θexpenses?.()
    }

    set expenses(expenses) {
        this.θexpenses.set(LowgileDataUtil.coerceDataType(expenses, Llama.Expense, true, true))
        this.expenses?.forEach?.(item => { if (item && "project" in item) item.project = this as any })
    }

    get customer(): Llama.Customer {
        return this.θcustomer?.()
    }

    set customer(customer) {
        this.θcustomer.set(LowgileDataUtil.coerceDataType(customer, Llama.Customer, false, true))
        if (customer) {
            this.θcustomerId.set(customer.id)
        } else if (customer === null && customer) {
            this.θcustomerId.set(null)
        }
    }

    get customerId(): Llama.Customer.Id {
        return this.θcustomerId?.()
    }

    set customerId(customerId) {
        if (customerId === null) this.θcustomer.set(null)
        if (this.customer?.id && customerId != this.customer.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θcustomerId.set(LowgileDataUtil.coerceDataType(customerId, 'string', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(LowgileDataUtil.coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(LowgileDataUtil.coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(LowgileDataUtil.coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(LowgileDataUtil.coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(LowgileDataUtil.coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(LowgileDataUtil.coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(LowgileDataUtil.coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Llama__Project>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                expenses: [],
                ...init
            }

        }

        LowgileDataUtil.assignCommonProperties(this, init)
        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Llama__Project()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Llama__Project>, restrictToClass?: Class<Partial<Llama__Project>>) {
        LowgileDataUtil.assignCommonProperties(this, source, { restrictToClass })
    }

    static $getSchema(): any {

        const key = ""
        if ($schemas.has(key)) return $schemas.get(key)!
        const schema = z.object({
            name: z.string(),
            locations: z.string().array(),
            isActive: z.boolean(),
            isInternal: z.boolean(),
            erpId: z.string(),
            ownerEmail: z.string(),
            get expenses() { return Llama.Expense.$getSchema().array() },
            get customer() { return Llama.Customer.$getSchema() },
            customerId: Llama.Customer.$getSchema().shape.id,
            createdOn: z.coerce.date(),
            get createdBy() { return System.UserIdAndName.$getSchema() },
            updatedOn: z.coerce.date(),
            get updatedBy() { return System.UserIdAndName.$getSchema() },
            deletedOn: z.coerce.date(),
            get deletedBy() { return System.UserIdAndName.$getSchema() },
            versionNumber: z.number(),
        }
        )
        $schemas.set(key, schema)
        return schema

    }

    $getSchema(): any {
        return Llama__Project.$getSchema()
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('name', 'locations', 'isActive', 'isInternal', 'erpId', 'ownerEmail', 'expenses', 'customer', 'customerId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Llama__Project {
        return equal(this, other)
    }
}

namespace Llama__Project { }

export import Project = Llama__Project
setTimeout(() => {
    jsonProperty(() => String)(Llama__Project.prototype, 'name')
    jsonArrayProperty(() => String)(Llama__Project.prototype, 'locations')
    jsonProperty(() => Boolean)(Llama__Project.prototype, 'isActive')
    jsonProperty(() => Boolean)(Llama__Project.prototype, 'isInternal')
    jsonProperty(() => String)(Llama__Project.prototype, 'erpId')
    jsonProperty(() => String)(Llama__Project.prototype, 'ownerEmail')
    jsonArrayProperty(() => Llama.Expense)(Llama__Project.prototype, 'expenses')
    jsonProperty(() => Llama.Customer)(Llama__Project.prototype, 'customer')
    jsonProperty(() => String)(Llama__Project.prototype, 'customerId')
    jsonProperty(() => Date)(Llama__Project.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Project.prototype, 'createdBy')
    jsonProperty(() => Date)(Llama__Project.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Project.prototype, 'updatedBy')
    jsonProperty(() => Date)(Llama__Project.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Llama__Project.prototype, 'deletedBy')
    jsonProperty(() => Number)(Llama__Project.prototype, 'versionNumber')
})

export const ProjectθId = String;

export type ProjectθId = string;

namespace Llama__Project {
    export type Id = NominalType<string, 'Llama.Project'>

}
